<form [formGroup]="accountForm" (ngSubmit)="saveUpdates()">
    <!-- Name Field -->
    <div class="row">
        <div class="col-md-6">
            <div class="formGroup mb-3">
                <label>Name:</label>
                <input formControlName="name" class="form-control" [readonly]="!isEditing.name" />
                <button type="button" (click)="toggleEdit('name')">
                    <i class="fas" [ngClass]="isEditing.name ? 'fa-times' : 'fa-edit'"></i> Edit
                </button>
            </div>
        </div>
        <div class="col-md-6">
            <!-- Phone Field -->
            <div class="formGroup mb-3">
                <label>Phone:</label>
                <input formControlName="phone" (input)="filterPhoneInput($event)" type="number" class="form-control" [readonly]="!isEditing.phone" />
                <button type="button" (click)="toggleEdit('phone')">
                    <i class="fas" [ngClass]="isEditing.name ? 'fa-times' : 'fa-edit'"></i> Edit
                </button>
            </div>
            <div class="text-danger"
            *ngIf="accountForm.get('phone').invalid && (accountForm.get('phone').dirty || accountForm.get('phone').touched)">
            <div *ngIf="accountForm.get('phone').errors?.['required']">Phone number is required.</div>
            <div *ngIf="accountForm.get('phone').errors?.['pattern']">Phone number must be 10 digits.</div>
        </div>
        </div>
        <div class="col-md-6">
            <!-- Email Field -->
            <div class="formGroup mb-3">
                <label>Email:</label>
                <input formControlName="email" class="form-control" [readonly]="!isEditing.email" />
                <button type="button" (click)="toggleEdit('email')">
                    <i class="fas" [ngClass]="isEditing.name ? 'fa-times' : 'fa-edit'"></i> Edit
                </button>
            </div>
            <div class="text-danger"
                        *ngIf="accountForm.get('email').invalid && (accountForm.get('email').dirty || accountForm.get('email').touched)">
                        <div *ngIf="accountForm.get('email').errors?.['required']">Email is required.</div>
                        <div *ngIf="accountForm.get('email').errors?.['pattern']">Invalid email address.</div>
                    </div>
        </div>
        <div class="col-md-6">
            <!-- Password Field -->
            <div class="formGroup mb-3">
                <label>Password:</label>
                <input type="password" class="form-control" formControlName="password" placeholder="*************"
                    [readonly]="!isEditing.password" />
                <button type="button" (click)="toggleEdit('password')">
                    <i class="fas" [ngClass]="isEditing.name ? 'fa-times' : 'fa-edit'"></i> Edit
                </button>
            </div>
            <div class="text-danger"
            *ngIf="accountForm.get('password').invalid && (accountForm.get('password').dirty || accountForm.get('password').touched)">
            <div *ngIf="accountForm.get('password').errors?.['required']">Password is required.</div>
            <div *ngIf="accountForm.get('password').errors?.['minlength']">Password must be at least 8
                characters
                long.</div>
            <div *ngIf="accountForm.get('password').errors?.['pattern']">
                <ul>
                    <li>Lowercase letters</li>
                    <li>Uppercase letters</li>
                    <li> Numbers</li>
                    <li>Special characters</li>
                </ul>
            </div>
        </div>
        </div>
        <div class="col-md-6">
            <!-- Title Field -->
            <div class="formGroup mb-3">
                <label>Title:</label>

                <select formControlName="title" class="form-control">
                    <option *ngFor="let type of farmTypes" [value]="type.value">
                        {{ type.name }}
                    </option>
                </select>

            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 text-right">
            <button class="btn btn-primary" [disabled]="!accountForm.dirty" type="submit">Save</button>
        </div>
    </div>
</form>